export default "__VITE_ASSET__ce927c4d__"